export const getExternalFulfillmentConfiguration = (fulfillmentPlan) => {
  const {
    fulfillmentPlanId,
    packingSlipTemplateId,
    shipmentEmailNotificationTemplateId,
    deliveryEmailNotificationTemplateId,
    sellerFulfillmentProviderId,
    fulfillmentServiceId,
    shipTo,
    shipDate,
    options,
  } = fulfillmentPlan;
  return {
    fulfillmentPlanId,
    packingSlipTemplateId,
    shipmentEmailNotificationTemplateId,
    deliveryEmailNotificationTemplateId,
    externalFulfillmentConfiguration: {
      sellerFulfillmentProviderId,
      fulfillmentServiceId,
      shipTo,
      additionalOptions: {
        ...options,
      },
    },
    // the old redux driven builder never included a shipDate but it is on the swagger
    shipDate,
  };
};
